<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-printer-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Aperçu avant impression</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between">
                            <div class="box-title">
                                {{titlemodal}}
                            </div>


                        </div>


                        <div class="box-body !p-0">

                            <div class="grid lg:grid-cols-2 gap-6">


                                <div class="space-y-2">
                                    <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Impression en</label>
                                    <select v-model="taillemodel" class="form-control mb-3">
                                        <option value="A4">Portrait</option>
                                        <option value="A4landscape">Paysage</option>
                                        <!--option value="A5">A5</option>
                                        <option value="A5landscape">A5 landscape</option-->
                                    </select>
                                </div>


                                <div  class="space-y-2">



                                </div>



                            </div>


                            <div class="grid lg:grid-cols-3 gap-6 mt-4">

                                <div class="space-y-2">
                                    <button @click="print4()" class="ti-btn ti-btn-success-full w-full"> Imprimer </button>


                                </div>

                                <div class="space-y-2">
                                    <button    @click="ExportExcel('xlsx',`${soustitre} `)"
                                               class="ti-btn ti-btn-danger-full  w-full"> Excel</button>
                                </div>


                            </div>








                            <div class="table-responsive mybodyheight300px">


                                <div ref="printdoc"  class="my-5 page pagebreak"  >


                                    <div class="p-5">

                                        <section class="top-content mb-5 bb d-flex justify-content-between">
                                            <div class="logo">
                                                <img v-if="$store.state.etatlogo" :src="$store.state.etatlogo" alt="" style="width: 10%" class="img-fluid">
                                            </div>
                                            <div class="top-left">
                                                <div class="logo">

                                                </div>
                                            </div>
                                        </section>

                                        <section class="mt-5">
                                            <div class="grid lg:grid-cols-2 gap-6 row">

                                                <div class="col-6">
                                                    <table class="table table-bordered">
                                                        <tbody >

                                                        <tr>
                                                            <td >Raison Social : {{$store.state.etatraisonsocial}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td >Ifu : {{$store.state.etatifu}} /  RC N° RCCM: {{$store.state.etatrccm}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td >Téléphone : {{$store.state.etattelephone}} / {{$store.state.etatadresse}}</td>
                                                        </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="col-6 ">


                                                    <table class="table table-bordered w-full">
                                                        <tbody >
                                                        <tr>
                                                            <td style="text-align: center" colspan="2" >{{soustitre}}</td>

                                                        </tr>
                                                        <tr>

                                                            <td style="text-align: center">JOURNEE DU</td>
                                                            <td style="text-align: center">IMPRIMER PAR</td>
                                                        </tr>
                                                        <tr>

                                                            <td style="text-align: center">{{tabvalue.date}}</td>
                                                            <td style="text-align: center">{{$store.state.appusername}}</td>
                                                        </tr>

                                                         <tr  >
                                                            <td style="text-align: center" colspan="2" >Imprimer le {{datenow}}</td>

                                                        </tr>




                                                        </tbody>
                                                    </table>


                                                </div>

                                            </div>


                                        </section>


                                        <section   class="product-area mt-3">



                                        </section>

                                        <section class="balance-info">



                                            <table ref="exportable_table" style="font-size: 14px;height: 600px;" class="table table-bordered w-full">

                                                <tbody>
                                                <tr>
                                                    <td colspan="2"><strong>Solde à l'ouverture</strong></td>
                                                    <td style="width:200px;text-align: right;font-weight: 800;">{{formatMoney(tabvalue.soldealouverture)}}</td>
                                                </tr>

                                                <tr>
                                                    <td ><strong>Espèces reçu</strong></td>
                                                    <td style="width:400px">
                                                        <table class="w-full" style="width: 100%;height: 100%;">
                                                            <tbody>
                                                            <tr  style="border-top: 2px solid white;border-left: 2px solid white;">
                                                                <td><strong>Banque</strong></td>

                                                            </tr>
                                                            <tr  style="    border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td><strong>Vente (Réglement Client)</strong></td>
                                                            </tr>
                                                            <tr  style="    border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td><strong>Autre</strong></td>
                                                            </tr>
                                                            <tr  style="border-bottom: 2px solid white;border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td><strong>Totale</strong></td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td>

                                                        <table class="w-full" style="width: 100%;height: 100%;">
                                                            <tbody>
                                                            <tr  style="border-top: 2px solid white;border-left: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.especesrecubaque)}}</td>
                                                            </tr>
                                                            <tr  style="    border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.especesrecuvente)}}</td>
                                                            </tr>
                                                            <tr  style="    border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.especesrecuautre)}}</td>
                                                            </tr>
                                                            <tr  style="border-bottom: 2px solid white;border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.totalespecerecu)}}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td ><strong>Paiement effectué</strong></td>
                                                    <td >
                                                        <table class="w-full" style="width: 100%;height: 100%;">
                                                            <tbody>
                                                            <tr  style="border-top: 2px solid white;border-left: 2px solid white;">
                                                                <td><strong>Espèces déposé à la banque / Transfert vers une caisse</strong></td>

                                                            </tr>
                                                            <tr  style="    border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td><strong>Espèces payé</strong></td>
                                                            </tr>
                                                            <tr  style="    border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td><strong>Réglement Fournisseur</strong></td>
                                                            </tr>
                                                            <tr  style="border-bottom: 2px solid white; border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td><strong>Totale</strong></td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td>

                                                        <table class="w-full" style="width: 100%;height: 100%;">
                                                            <tbody>
                                                            <tr style="border-top: 2px solid white;border-left: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.paiementbanque)}}</td>
                                                            </tr>
                                                            <tr style="    border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.paiementdepense)}}</td>
                                                            </tr>
                                                            <tr style="border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.paiementachat)}}</td>
                                                            </tr>
                                                            <tr style="border-bottom: 2px solid white;border-left: 2px solid white;border-right: 2px solid white;">
                                                                <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.totalpaiement)}}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colspan="2"><strong>Montant à la fermeture</strong></td>
                                                    <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.montantalafermeture)}}</td>
                                                </tr>

                                                <tr>
                                                    <td colspan="2"><strong>Montant physique</strong></td>
                                                    <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.montantphysique)}}</td>
                                                </tr>

                                                <tr>
                                                    <td colspan="2"><strong>Montant attendu</strong></td>
                                                    <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.montantattendu)}}</td>
                                                </tr>

                                                <tr>
                                                    <td colspan="2"><strong>Ecart</strong></td>
                                                    <td style="text-align: right;font-weight: 800;">{{formatMoney(tabvalue.montantecart)}}</td>
                                                </tr>



                                                </tbody>

                                            </table>



                                        </section>
                                        <section class="balance-info mt-3">
                                            <div class="grid grid-cols-2  gap-x-6 mt-3 row">
                                                <div class="col-6 ">

                                                    <div style="float: left;    margin-left: 80px;">
                                                        <p style="text-align: center;font-size: 16px;"  class="m-0 font-weight-bold"> Caissier </p>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <p style="text-align: center;font-size: 16px;" >{{tabvalue.docsaisiepar}}</p>
                                                    </div>

                                                </div>

                                                <div class="col-6 ">

                                                    <div style="float: right;margin-right: 85px;">
                                                        <p style="text-align: center;"  class="m-0 font-weight-bold"> {{tabvalue.caisseresponsable.titre}} </p>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <p style="text-align: center;" >{{tabvalue.caisseresponsable.name}}</p>
                                                    </div>


                                                </div>
                                            </div>
                                        </section>



                                    </div>




                                </div>




                            </div>


                        </div>



                    </div>






                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="print4" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Imprimer</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>
</template>

<script>
    /*import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";*/
    import {
        currencyFormatDE, currencyFormatMonney,
        currentDate,
        currentDateTime,
        ExportExcel, FormatNumber,
        getYear,
        impression, NumbertoLettre,
    } from "@/allfunction";

    import qrcode from 'qrcode.vue'


    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {


        },
        computed:{

            soustitre(){
                this.taillemodel='A4';  return "ETAT DE PAIEMENT DE LA JOURNEE DU "+this.tabvalue.date
            },



        },
        components: {
            /*templatesite,
            appheader,
            appsidebar,
            appmenu,*/
            qrcode

        },

        data() {
            return {

                mfontsize:10,
                taillemodel:'A4',
                mgetyear:getYear(),
                datenow:currentDate(),
                hidecolums:true,
                isdisplay:false,
                viewperiode:false,
                titlemodal:"",
                datatable:[],
                viewdrop:false,
                tabvalue:{},
                selectedaffichage:'',
                datejournee:"",
                datedebut:"",
                numpidcaisse:"",
                datefin:"",
                searchnomcaisse:"",
                searchbeneficiaire:"",
                typedoc:"",







                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 1,
                Defaultpage: 1,
                DefaultperPage: 1,
                pages: [],

                textToEncode: '',  // Initial text to encode in QR code
                size: 100,              // Size of the QR code
                level: 'L'              // Error correction level ('L', 'M', 'Q', 'H')
            };
        },
        methods: {



            formatMonney(value){
                return currencyFormatMonney(value)

            },


            numbertolettre(chiffre){

                return NumbertoLettre(chiffre)

            },



            ExportExcel(type,name, fn, dl) {
                name=name+"_"+currentDateTime()
                var elt = this.$refs.exportable_table;
                ExportExcel(type,name, fn, dl,elt);

            },



            async print4 () {

                this.hidecolums=false;
                let t=this
                let $style=[];

                let options = {  name: '_blank', }


                if (this.taillemodel==="A4landscape" || this.taillemodel==="A5landscape" ){

                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/stylelandscape1.css',
                        process.env.VUE_APP_URL+'print/stylelandscape.css'
                    ]


                }

                if (this.taillemodel==="A4" || this.taillemodel==="A5" ){


                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/styleportrait.css',
                        // process.env.VUE_APP_URL+'print/custom_print_a4.css',
                    ]

                }



                const printContent = this.$refs.printdoc.innerHTML;



               await impression(printContent,$style,window.document.title,[],{ format: this.taillemodel })
                   .then(result => {
                       console.log(result); // "Impression terminée avec succès"
                       this.hidecolums=true;
                   })
                   .catch(error => {
                       console.error(error);
                       this.hidecolums=true;
                   });

            },



            formatMoney(value){
                return currencyFormatDE(value)

            },


            formatnumber(value){
                return FormatNumber(value)

            },



            returnFloatconvert(value){

                //console.log('value ',value)

                let mval= parseFloat(value)

                return mval.toFixed(4)
            },

            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },




            checkZero(i)
            {
                if (i < 10)
                {
                    i = "0" + i
                };  // add zero in front of numbers < 10

                return i;
            },

            async show(value){

                this.datatable=[]

                this.titlemodal="ETAT DE PAIEMENT"
                this.tabvalue=value


                this.isdisplay=true;
            },



        },
        mounted() {


        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xl { max-width:100%; }


        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>